import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PreScreening from './pages/PreScreening';
import DataAnalysis from './pages/DataAnalysis';
import Home from './pages/Home';
import DashboardLayout from './components/DashboardLayout';
import { TooltipProvider } from './providers/TooltipContext';

function App() {
  return (
    <TooltipProvider>
      <Router>
        <Routes>
          <Route path="/" element={<DashboardLayout><PreScreening /></DashboardLayout>} />
          <Route path="/pre-screening" element={<DashboardLayout><PreScreening /></DashboardLayout>} />
          <Route path="/data-analysis" element={<DashboardLayout><DataAnalysis /></DashboardLayout>} />
        </Routes>
      </Router>
    </TooltipProvider>
  );
}

export default App;
